import React from 'react';

const Home = () => {
    return (
        <div>
            <h1>Bienvenido a FloraCore</h1>
        </div>
    );
};

export default Home;